import {
	AppBar,
	Button,
	Dialog,
	Menu,
	MenuItem,
	Slide,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Column } from 'react-table';
import { Dispatch } from 'redux';
import MessageDialog from 'src/components/MessageDialog';
import SkillScenarioFactory, {
	ISkillParam,
} from 'src/scenario/SkillScenarioFactory';
import { Routes, Screens } from 'src/utils/Routes';
import * as Actions from '../actions/skill';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import Config from '../site.config.json';
import CertificationFileUpload from './CertificationFileUpload';
const ITEM_HEIGHT = 48;

const styles = ({ spacing }: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		certer: {
			textAlign: 'center',
		},
		costStyle: {
			textAlign: 'right',
		},
		dialog: {
			width: '55%',
		},
		innerButton: {
			fontSize: '0.625rem',
			marginLeft: spacing(1),
			marginRight: spacing(1),
			minWidth: 48,
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		menuButton: {
			height: '32px',
			width: '32px',
		},
		pointer: {
			cursor: 'pointer',
		},
		rowBlue: {
			'&:hover': {
				backgroundColor: '#CEDDFF !important',
			},
			backgroundColor: '#D9E5Ff !important',
		},
		rowGray: {
			'&:hover': {
				backgroundColor: '#E5E5E5 !important',
			},
			backgroundColor: '#EEEEEE !important',
		},
		rowOrange: {
			'&:hover': {
				backgroundColor: '#FFEFBC !important',
			},
			backgroundColor: '#FFF4D1 !important',
		},
		rowPink: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
	});

export enum SkillTableTypes {
	ONGOING,
	RESULT,
}

interface IState {
	functionMenus?: JSX.Element;
	selectColumnsMenuAnchorEl?: HTMLElement;
	DialogOpen: boolean;
	DialogMessage: string;
	certificationUploadDialog: boolean;
	careerID: string;
	classID: string;
	reasonCode: string;
	seq: string;
}

class ISkillTable extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			DialogMessage: '',
			DialogOpen: false,
			careerID: '',
			certificationUploadDialog: false,
			classID: '',
			reasonCode: '',
			selectColumnsMenuAnchorEl: undefined,
			seq: '',
		};
	}

	public componentWillUpdate(nextProps: IProps) {
		if (this.props.data !== nextProps.data) {
			return true;
		}
		return false;
	}

	public render() {
		const { classes } = this.props;
		const columns = this.getSelectedColumns();

		return (
			<>
				<ReactTable
					data={this.props.data}
					columns={columns}
					defaultPageSize={5}
					className="-striped -highlight"
					getTrProps={this.setRowColor(classes)}
					getTdProps={this.setColumn(classes)}
					columnsMenu={true}
					menuHandler={this.handleSelectColumns}
				/>
				{this.state.selectColumnsMenuAnchorEl &&
					this.getSelectColumnsMenu()}
				{this.state.functionMenus}
				<MessageDialog
					open={this.state.DialogOpen}
					showCancelButton={false}
					title={i18n.t('SkillTable_0001')}
					contents={[{ content: this.state.DialogMessage }]}
					onClose={this.errorMessageExpiredDialogClose}
					onClickOk={this.errorMessageExpiredDialogClose}
				/>
				<Dialog
					fullScreen={false}
					TransitionComponent={Transition}
					open={this.state.certificationUploadDialog}
					onClose={this.handleCloseDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: classes.dialog,
					}}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handleCloseDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('SkillTable_0002')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CertificationFileUpload
						careerID={this.state.careerID}
						classID={this.state.classID}
						seq={this.state.seq}
						reasonCode={this.state.reasonCode}
					/>
				</Dialog>
			</>
		);
	}

	protected errorMessageExpiredDialogClose = () => {
		this.setState({
			DialogMessage: '',
			DialogOpen: false,
		});
	};

	protected outOfPeriodHandler = () => {
		this.setState({
			DialogMessage: 'LMCM_E_15100',
			DialogOpen: true,
		});
	};

	/**
	 * 全列情報取得
	 */
	protected getAllColumns(): any[] {
		const { classes, handleShowSkillDetailDialog } = this.props;
		if (this.props.type === SkillTableTypes.ONGOING) {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup={'true'}
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Header: i18n.t('SkillTable_0003'),
					accessor: 'compulsoryID',
					show: false,
					width: 80,
				},
				{
					Header: i18n.t('SkillTable_0004'),
					accessor: 'careerSubTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								data-skillid={row.original.careerID}
								onClick={handleShowSkillDetailDialog}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: i18n.t('SkillTable_0005'),
					accessor: 'careerTitle',
					show: false,
					width: 280,
				},
				{
					Cell: (row: RowRenderProps) => {
						const skillType = row.value;
						if (
							skillType === '資格' ||
							skillType === '業務経験' ||
							skillType === 'スキル診断'
						) {
							return i18n.t(skillType, { ns: 'force' });
						} else {
							return skillType;
						}
					},
					Header: i18n.t('SkillTable_0006'),
					accessor: 'skillType',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('SkillTable_0007'),
					accessor: 'jissiKikan',
					show: false,
					width: 300,
				},
				{
					Cell: (row: RowRenderProps) =>
						row.original.classID === 'CL000000'
							? i18n.t(row.value, { ns: 'force' })
							: row.value,
					Header: i18n.t('SkillTable_0008'),
					accessor: 'classTitle',
					show: false,
					width: 280,
				},
				{
					Cell: (row: RowRenderProps) =>
						i18n.t(row.value, { ns: 'force' }),
					Header: i18n.t('SkillTable_0009'),
					accessor: 'status',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.statusOnGoingFlg) {
							if (
								row.original.outOfPeriodFlg &&
								row.original.assessmentExistFlg
							) {
								return (
									<Button
										variant="contained"
										color="default"
										size="small"
										onClick={this.outOfPeriodHandler}
									>
										{i18n.t('SkillTable_0010')}
									</Button>
								);
							}
							if (
								!row.original.outOfPeriodFlg &&
								row.original.assessmentExistFlg
							) {
								if (row.original.assessmentAnswerFlg) {
									return (
										<Button
											variant="contained"
											color="primary"
											size="small"
											onClick={this.handleOpenAssessment(
												row
											)}
										>
											{i18n.t('SkillTable_0011')}
										</Button>
									);
								} else {
									return (
										<Button
											variant="contained"
											color="primary"
											size="small"
											onClick={this.handleOpenAssessment(
												row
											)}
										>
											{i18n.t('SkillTable_0012')}
										</Button>
									);
								}
							}
						}
						return <div>---</div>;
					},
					Header: i18n.t('SkillTable_0013'),
					accessor: 'assessment',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0014'),
					accessor: 'target',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let credit = row.value;
						if (credit !== null) {
							credit = credit.substring(0, credit.length - 2);
							return i18n.t('SkillTable_0032', {
								credit,
							});
						} else {
							return credit;
						}
					},
					Header: i18n.t('SkillTable_0015'),
					accessor: 'credit',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0016'),
					accessor: 'organizer',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0017'),
					accessor: 'cost',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('SkillTable_0018'),
					accessor: 'mousikomiKikan',
					show: false,
				},
			];
		} else {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup={'true'}
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Header: i18n.t('SkillTable_0003'),
					accessor: 'compulsoryID',
					show: false,
					width: 80,
				},
				{
					Header: i18n.t('SkillTable_0004'),
					accessor: 'careerSubTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								data-skillid={row.original.careerID}
								onClick={handleShowSkillDetailDialog}
							>
								{row.original.careerTitle}
							</span>
						);
					},
					Header: i18n.t('SkillTable_0005'),
					accessor: 'careerTitle',
					show: false,
					width: 300,
				},
				{
					Cell: (row: RowRenderProps) => {
						const skillType = row.value;
						if (
							skillType === '資格' ||
							skillType === '業務経験' ||
							skillType === 'スキル診断'
						) {
							return i18n.t(skillType, { ns: 'force' });
						} else {
							return skillType;
						}
					},
					Header: i18n.t('SkillTable_0006'),
					accessor: 'skillType',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0019'),
					accessor: 'complDate',
					show: false,
					width: 200,
				},
				{
					Header: i18n.t('SkillTable_0020'),
					accessor: 'testResult',
					show: false,
					width: 100,
				},
				{
					Cell: (row: RowRenderProps) =>
						i18n.t(row.value, { ns: 'force' }),
					Header: i18n.t('SkillTable_0021'),
					accessor: 'contents',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.sikkouFlg === '1') {
							return (
								<span style={{ color: 'red' }}>
									{i18n.t(row.original.status, {
										ns: 'force',
									})}
								</span>
							);
						} else {
							return (
								<div>
									{i18n.t(row.original.status, {
										ns: 'force',
									})}
								</div>
							);
						}
					},
					Header: i18n.t('SkillTable_0009'),
					accessor: 'status',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0022'),
					accessor: 'validDate',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0014'),
					accessor: 'target',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let credit = row.value;
						if (credit !== null) {
							credit = credit.substring(0, credit.length - 2);
							return i18n.t('SkillTable_0032', {
								credit,
							});
						} else {
							return credit;
						}
					},
					Header: i18n.t('SkillTable_0015'),
					accessor: 'credit',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0016'),
					accessor: 'organizer',
					show: false,
				},
				{
					Header: i18n.t('SkillTable_0017'),
					accessor: 'cost',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						let period = row.value;
						if (period && period.indexOf('～') !== -1) {
							period = period.replace(
								'～',
								i18n.t('～', {
									ns: 'force',
								})
							);
						}
						return period;
					},
					Header: i18n.t('SkillTable_0018'),
					accessor: 'mousikomiKikan',
					show: false,
				},
			];
		}
	}

	/**
	 * 選択中列情報取得
	 */
	protected getSelectedColumns() {
		const columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		return columns;
	}

	/**
	 * 列選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const checkboxList: any[] = [];

		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="logout-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 行メニュー取得
	 * @param functionMenuAnchorEl アンカー要素
	 * @param rowData 行情報
	 */
	protected getFunctionMenus(
		functionMenuAnchorEl: HTMLElement,
		rowData: Actions.IOnGoingSkill | Actions.IResultSkill
	) {
		let rowOnGoing: Actions.IOnGoingSkill | null = null;
		let rowResult: Actions.IResultSkill | null = null;
		if (this.props.type === SkillTableTypes.ONGOING) {
			rowOnGoing = rowData as Actions.IOnGoingSkill;
		} else {
			rowResult = rowData as Actions.IResultSkill;
		}
		return (
			<Menu
				anchorEl={functionMenuAnchorEl}
				open={true}
				onClose={this.handleCloseMenu}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						width: 300,
					},
				}}
			>
				<MenuItem onClick={this.showDetail(rowData)}>
					{i18n.t('SkillTable_0023')}
				</MenuItem>
				{rowOnGoing && rowOnGoing.appChangeOkFlg && (
					<MenuItem
						onClick={this.handleShowChangeApplication(rowOnGoing)}
					>
						{i18n.t('SkillTable_0024')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.appCancelOkFlg && (
					<MenuItem
						onClick={this.handleShowCancelApplication(rowOnGoing)}
					>
						{i18n.t('SkillTable_0025')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.lecCancelOkFlg && (
					<MenuItem onClick={this.handleShowStCancel(rowOnGoing)}>
						{i18n.t('SkillTable_0026')}
					</MenuItem>
				)}
				{rowOnGoing && rowOnGoing.appResultOkFlg && (
					<MenuItem
						onClick={this.handleShowActResultApplication(
							rowOnGoing
						)}
					>
						{i18n.t('SkillTable_0027')}
					</MenuItem>
				)}
				{rowResult && (
					<MenuItem
						onClick={this.handleShowActResultReference(rowResult)}
					>
						{i18n.t('SkillTable_0028')}
					</MenuItem>
				)}
				{rowResult && rowResult.certificateUploadFlg && (
					<MenuItem onClick={this.handCertificationUpload(rowResult)}>
						{i18n.t('SkillTable_0029')}
					</MenuItem>
				)}
				{rowResult && rowResult.certificateDispFlg && (
					<MenuItem onClick={this.showCertificate(rowResult)}>
						{i18n.t('SkillTable_0030')}
					</MenuItem>
				)}
				{rowResult && rowResult.assessMentResultDispFlg && (
					<MenuItem
						onClick={this.handleOpenAssessmentResult(rowResult)}
					>
						{i18n.t('SkillTable_0031')}
					</MenuItem>
				)}
			</Menu>
		);
	}

	/**
	 * 詳細情報表示
	 */
	protected showDetail = (
		rowData: Actions.IOnGoingSkill | Actions.IResultSkill
	) => () => {
		let to = Routes.getPath(Screens.PERSONAL_SKILL_DETAIL);
		to = to.replace(/\/:skill_id/, `/${rowData.careerID}`);
		this.props.pushHistory(to);
	};

	/**
	 * 実績申請画面表示
	 */
	protected handleShowActResultApplication = (
		rowData: Actions.IOnGoingSkill
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID, classID } = rowData;
		const userId = this.props.userId;
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:nittei_only_flg/, `/0`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			skillViewFlg: true,
			userId,
		});
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 証明書表示
	 * @param e イベントオブジェクト
	 */
	protected showCertificate = (rowData: Actions.IResultSkill) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID, reasonCode, seq } = rowData;
		const { userAttr } = this.props;

		let url =
			Config.tsqPath + '/tsq/pkg/action/per/skillCertificate.action?';
		url = url + 'accessType=10';
		url = url + '&userId=' + userAttr.userId;
		url = url + '&careerID=' + careerID;
		url = url + '&classID=' + classID;
		url = url + '&reasonCode=' + reasonCode;
		url = url + '&seq=' + seq;
		window.open(url, '_blank');
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請変更画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowChangeApplication = (
		rowData: Actions.IOnGoingSkill
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { careerID, classID } = rowData;

		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			skillViewFlg: true,
		});
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 実績参照画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowActResultReference = (
		rowData: Actions.IResultSkill
	) => (e: React.MouseEvent<HTMLElement>) => {
		const {
			careerID,
			classID,
			seq,
			imstatListStatusId,
			reasonCode,
		} = rowData;
		const userId = this.props.userId;
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_REFERENCE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:seq/, `/${seq}`);
		const state = {
			careerID,
			classID,
			imstatListStatusId,
			reasonCode,
			seq,
			skillViewFlg: true,
			userId,
		};
		this.props.pushHistoryState(to, state);
		this.setState({ functionMenus: undefined });
	};

	/**
	 * スキル実施取消画面
	 * @param e イベントオブジェクト
	 */
	protected handleShowStCancel = (rowData: Actions.IOnGoingSkill) => (
		e: React.MouseEvent<HTMLElement>
	) => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:curriculum_flg/, `/0`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			skillViewFlg: true,
		});
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected handleShowCancelApplication = (
		rowData: Actions.IOnGoingSkill
	) => (e: React.MouseEvent<HTMLElement>) => {
		const { aplType, careerID, classID } = rowData;

		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:apl_type/, `/${aplType}`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			skillViewFlg: true,
		});
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 行カラー設定
	 */
	protected setRowColor = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		let className: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			className = classes.rowPink;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			className = classes.rowOrange;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			className = classes.rowBlue;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			className = classes.rowGray;
		}

		return {
			className,
		};
	};

	/**
	 * 列設定
	 */
	protected setColumn = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo,
		column?: Column
	) => {
		if (column === undefined) {
			return {};
		}
		let className: string = '';
		if (column.id === 'cost') {
			className = classes.costStyle;
		}

		if (
			column.id === 'assessment' ||
			column.id === 'jissiKikan' ||
			column.id === 'status' ||
			column.id === 'cost' ||
			column.id === 'credit' ||
			column.id === 'mousikomiKikan' ||
			column.id === 'complDate' ||
			column.id === 'testResult' ||
			column.id === 'validDate'
		) {
			className = classes.certer;
		}
		return {
			className,
		};
	};

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			if (this.props.type === SkillTableTypes.ONGOING) {
				const rowData: Actions.IOnGoingSkill = this.props.data[index];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			} else if (this.props.type === SkillTableTypes.RESULT) {
				const rowData: Actions.IResultSkill = this.props.data[index];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			}
		}
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 列選択メニューハンドラ
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 列選択メニュークローズハンドラ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * チェックボックス変更ハンドラ
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		if (this.props.type === SkillTableTypes.ONGOING) {
			this.props.setOnGoingSelectedColumns(newSelectedColumns);
		} else if (this.props.type === SkillTableTypes.RESULT) {
			this.props.setResultSelectedColumns(newSelectedColumns);
		}
	};

	protected handleCloseDialog = () => {
		const param: ISkillParam = {
			adminView: this.props.adminView,
			userAttr: this.props.userAttr,
			userId: this.props.userId,
		};
		this.props.doFetchResultSkill(this.props.token, param);
		this.setState({
			careerID: '',
			certificationUploadDialog: false,
			classID: '',
		});
	};

	/**
	 * 認定証アップロード
	 * @param rowResult
	 */
	protected handCertificationUpload = (rowResult: Actions.IResultSkill) => (
		event: any
	) => {
		const { careerID, classID, reasonCode, seq } = rowResult;
		this.setState({
			careerID,
			certificationUploadDialog: true,
			classID,
			functionMenus: undefined,
			reasonCode,
			seq,
		});
	};

	/**
	 * アセスメント回答結果表示
	 */
	protected handleOpenAssessmentResult = (
		rowResult: Actions.IResultSkill
	) => (event: any) => {
		const { careerID, classID, rankID } = rowResult;
		let to = Routes.getPath(Screens.PERSONAL_ASSESSMENT_RESULT);
		to = to.replace(/\/:career_id\//, `/${careerID}/`);
		to = to.replace(/\/:class_id\//, `/${classID}/`);
		to = to.replace(/\/:rank_id/, `/${rankID}`);
		this.props.pushHistory(to);
	};

	/**
	 * アセスメント回答
	 */
	protected handleOpenAssessment = (row: RowRenderProps) => (event: any) => {
		const { careerID, classID, careerTitle } = row.original;
		const flg = row.original.assessmentAnswerFlg ? 1 : 2;
		this.props
			.fetchAssessmentInfo(this.props.token, careerID)
			.then(data => {
				const id = data.assessmentid;
				const type = data.assessmenttype;
				if (id && type) {
					let to = Routes.getPath(Screens.PERSONAL_ASSESSMENT_FORM);
					to = to.replace(/\/:career_id\//, `/${careerID}/`);
					to = to.replace(/\/:class_id\//, `/${classID}/`);
					to = to.replace(/\/:questionnaire_id\//, `/${id}/`);
					to = to.replace(/\/:type$/, `/${type}`);
					this.props.pushHistoryState(to, {
						careerName: careerTitle,
						flgcommit: flg,
					});
				}
			});
	};
}

const Transition: React.FC<any> = props => {
	return <Slide direction="up" {...props} />;
};

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	doFetchResultSkill: (token: string, skillParam: ISkillParam) => {
		const s = SkillScenarioFactory.createDoFetchResultSkill(
			dispatch,
			token
		);
		return s.run(skillParam);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setOnGoingSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setOnGoingSkillSelectedColumns({
				selectedColumns,
			})
		),
	setResultSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setResultSkillSelectedColumns({
				selectedColumns,
			})
		),

	fetchAssessmentInfo: (token: string, careerID: string) => {
		const s = SkillScenarioFactory.createDoFetchAssessmentInfo(
			dispatch,
			token
		);
		return s.run(careerID);
	},
});

interface ISkillTableProps {
	data: Actions.IOnGoingSkill[] | Actions.IResultSkill[];
	selectedColumns: number[];
	type: SkillTableTypes;
	userId: string;
	adminView: boolean;

	handleShowSkillDetailDialog: (e: React.MouseEvent<HTMLElement>) => void;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISkillTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ISkillTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/SkillTable.tsx